import { usePageProps } from '~components/PagePropsProvider';
import { removeTrailingSlash } from '~utils/string';

type Breadcrumb = {
  label: React.ReactNode;
  path: string;
};

export const useBreadcrumbs = (): Breadcrumb[] => {
  const { pageContext } = usePageProps();

  return removeTrailingSlash((pageContext as any).pagePath)
    .split('/')
    .reduce((breadcrumbs, item, index, arr) => {
      breadcrumbs.push({
        label: item ? item.replace(/-/g, ' ') : '/',
        path: arr.slice(0, index + 1).join('/') + '/' || '/',
      });
      return breadcrumbs;
    }, [] as Breadcrumb[]);
};
